<script setup lang="ts">
import { computed, provide } from "vue";
import {
  CONTROLS_DESIGN_VERSION,
  DEFAULT_DESIGN_VERSION,
  DESIGN_VERSION,
  type ControlsDesignVersion,
  type DesignVersion,
} from "../models";

export type BcDesignContextProps = {
  design?: DesignVersion;
};

const { design = DEFAULT_DESIGN_VERSION } = defineProps<BcDesignContextProps>();

const _design = computed<DesignVersion>(() => design);
const _controlsDesign = computed<ControlsDesignVersion>(() =>
  design === "6" ? "6" : "7",
);

provide(DESIGN_VERSION, _design);
provide(CONTROLS_DESIGN_VERSION, _controlsDesign);
</script>

<template>
  <slot></slot>
</template>
